import { render } from "./AddEditRecipe.vue?vue&type=template&id=7a4fe96a"
import script from "./AddEditRecipe.vue?vue&type=script&lang=js"
export * from "./AddEditRecipe.vue?vue&type=script&lang=js"

import "./AddEditRecipe.vue?vue&type=style&index=0&id=7a4fe96a&lang=scss"

import exportComponent from "/home/los7/Documents/Sites/IntendedMe/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__